export const API_GET_VOUCHER_AUTHORIZED = "/comprobantes/autorizados/";

export const API_GET_SEARCH_AUTHORIZED = "/comprobantes/autorizados/busqueda/";

export const API_GET_VOUCHER_BY_CUFE = "/comprobante/buscar/cufeReferenciado/";

export const API_GET_VOUCHER_BY_CUFE_2 = "/comprobante/buscar/cufe/";
